<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">腾讯云智能数智人、企点客服全面接入DeepSeek！</div>
      <div class="news-date">2025年2月25日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/ai_logo.gif"/>
          </div>
        </div>
        <p>2月24日，腾讯云智能数智人、腾讯企点客服宣布接入DeepSeek大模型。</p>
        <p>借助DeepSeek大模型优秀的语义理解和意图识别能力，数智人进一步优化交互、播报等场景的用户体验，企点客服则实现了问答质量和客户满意度的双重提升。</p>
        <div class="news-content-mark">
          <div>智能数智人：一键生成真人形象，DeepSeek直接「开口说话」</div>
        </div>
        <p>目前，腾讯云智能数智人全面接入DeepSeek大模型，用户通过数智人平台内置的V3、R1等模型，无需开发就可以让DeepSeek拥有真人外观，变得能说会道。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news70.webp"/>
          </div>
        </div>
        <p>在具体应用中，DeepSeek加持下的数智人在「交互场景」和「播报场景」中都有更为出色的表现：</p>
        <p>
          ●
          <span class="mark-text highlight">交互场景</span>
          ：在政策问答、景区导览、展厅接待等场景中快速整合多源信息，提供精准解答，并支持多轮对话与上下文理解；
        </p>
        <p>●
          <span class="mark-text highlight">播报场景</span>
          ：口播、营销文案生成口语化表达更自然，配合数智人全新推出的“2D小样本-免定制”数智人，分钟级完成从文案到成品视频的输出。
        </p>
        <p>体验路径也很简单：</p>
        <p>
          ● 登陆
          <span class="mark-text highlight">腾讯云智能数智人平台</span>
          ；
        </p>
        <p>● 进入到腾讯云智能数智人平台，创建数字人会话项目；</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news70/news70_1.webp"/>
          </div>
        </div>
        <p>
          ● 可根据需求在大模型配置中选择DeepSeek V3或者DeepSeek R1。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news70/news70_2.webp"/>
          </div>
        </div>
        <p>快来腾讯云体验一下「真人版」DeepSeek吧！</p>
        <div class="news-content-mark">
          <div>腾讯企点客服：「联网搜索」+「DeepSeek大脑」，服务更智能</div>
        </div>
        <p>如果说数字人让企业服务更有温度，那么智能客服则让温度产生更多价值。</p>
        <p>企点客服搭建了实时联网搜索与DeepSeek大模型联动的客服解决方案。腾讯企点客服机器人不仅能全网实时冲浪，还拥有超强大脑，更懂如何「让客户满意」，可服务于政务、零售、文旅、金融等多个行业。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news70/news70_3.webp"/>
          </div>
        </div>
        <p>具体而言，智能客服在知识密集型问答场景的回复「准确率」显著提升，大幅降低模型幻觉，显著提升客户服务满意度。</p>
        <p>那么，企点客服擅长应对哪些业务场景呢？</p>
        <p>
          ●
          <span class="mark-text highlight">满减优惠计算</span>
          ：帮助用户分步拆解消费金额与满减规则，智能匹配出最佳优惠组合，消费者买得开心，品牌销量蹭蹭往上涨；
        </p>
        <p>
          ●
          <span class="mark-text highlight">多种相似产品型号识别</span>
          ：精准分辨及检索相似产品型号，即使输入错误型号也能识别出客户实际想询问的型号；
        </p>
        <p>
          ●
          <span class="mark-text highlight">简化复杂产品信息</span>
          ：以人性化语言转化专业术语，以可视化表格降低理解门槛。
        </p>
        <p>值得一提的是，针对政府、金融等行业需求，腾讯企点客服搭建了数据加密传输、内容安全过滤、访问权限控制的三层防护机制，确保企业知识资产、对话服务全流程安全合规。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news70/news70_4.webp"/>
          </div>
        </div>
        <p>
          进入
          <span class="mark-text highlight">腾讯企点客服「官网」</span>
          ，点击右下角「申请体验」，就会有专属服务人员为您安排产品体验。
        </p>
        <p>欢迎大家来体验！</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News67',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .right-text {
    font-size: 12px;
    text-align: right;
    color: #0152d9;
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
  .short-center{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News70.vue